<template>
  <div class="modal-backdrop">
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <h1>FTP Server</h1>
        <div class="tab">
          <div class="params">
            <h2>Zugangsdaten:</h2>
            <div class="form">
              <input v-model="url" class="text" placeholder="URL eingeben.." />
              <input
                v-model="user"
                class="text"
                placeholder="benutzername eingeben.."
              />
              <input
                v-model="password"
                class="text"
                type="password"
                placeholder="Passwort eingeben.."
              />
            </div>
            <div v-show="false">
              <h2>Filter:</h2>
              <div>
                <input class="text" placeholder="Filter eingeben.." />
              </div>
            </div>
            <button class="btn-green" @click="close">Speichern</button>
          </div>
          <div class="folder-content">
            <div class="file-wrapper" v-for="f in files" :key="f">
              <img class="logo" v-bind:src="getImgUrl('./file-icon.png')" />
              <div class="filename">{{ f }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ftp',
  data() {
    return {
      url: 'sftp.datasource.eex-group.com/market_data/power/de/derivatives/csv/2020/20200603',
      user: 'EEX_574',
      password: 'e%wsY?38Z$',
      renderComponent: true,
    };
  },
  props: {
    task: Object,
    input: Array,
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
    series(id) {
      return id == -1 ? null : this.Input[id].series;
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    getImgUrl: function (img) {
      var images = require.context('../../assets/img/', false, /\.png$/);
      return images(img);
    },
    runnerApi: function () {
      if (location.host == 'localhost:8080') var url = 'http://127.0.0.1:1300';
      else
        var url =
          'https://1x22biunj0.execute-api.eu-central-1.amazonaws.com/dev';
      return url;
    },
  },

  asyncComputed: {
    files: {
      get() {
        var formData = new FormData();
        formData.append('url', this.Url);
        var apiUrl = this.runnerApi();
        apiUrl += '/files';
        apiUrl += '?url=' + encodeURIComponent(this.url);
        apiUrl += '&user=' + this.user;
        apiUrl += '&password=' + this.password;
        return this.$http
          .get(apiUrl)
          .then((response) => response.json())
          .then((json) => JSON.parse(json));
      },
      default() {
        return [];
      },
      watch: ['url', 'user', 'password'],
    },
  },

  computed: {},
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 1020px;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h2 {
  text-align: center;
}

h3 {
  color: rgba(85, 93, 109, 0.38);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 12px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #f9f9fb;
  padding: 12px 12px 50px 20px;
  min-height: 560px;
}

input,
select,
.text {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 15px;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 300;
  width: 100%;
}

select {
  width: 72%;
  font-size: 14px;
}

.imput-group > select {
  width: 40%;
}

.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.modal .btn-close {
  width: 13px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .datetime {
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 35px 15px 45px 15px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.logo {
  width: 87px;
}

.params {
  float: left;
  width: 30%;
}

.params > h2 {
  padding-top: 0;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #797c81;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  text-transform: uppercase;
  text-align: left;
}

.folder-content {
  float: right;
  width: 790px;
  background: #fff;
  padding: 20px;
  height: 760px;
  zoom: 0.7;
  padding: 20px;
  border: 1px solid #e5eaf4;
  /*box-shadow: inset 0 0 12.09p
    x 0.91px rgba(27,32,43,.2);*/
  overflow: scroll;
}

.large {
  height: 112px;
  font-size: 14px;
  font-weight: 300;
}

.text {
  border: none;
  background: none;
  line-height: 10px;
  padding-bottom: 0;
  padding-top: 0;
  height: 40px;
  border-bottom: 1px solid #dee3e9;
}

.text.large {
  line-height: 18px;
  height: 66px;
}

label {
  line-height: 50px;
  font-size: 14px;
  font-weight: 300;
}

table {
  width: 100%;
}

table td tr {
  width: 100%;
}

.chart {
  position: relative;
  box-shadow: none;
  transform: none;
  width: auto;
  top: 0;
  left: 0;
  height: 230px;
  width: 310px;
  border: none;
  padding: 0px 35px 35px 15px;
}

.chart-wrapper {
  width: 310px;
}

.form {
  min-height: 200px;
}

.folder-content h3 {
  color: inherit;
  text-align: center;
  font-weight: 400;
}

.filename {
  overflow: hidden;
  margin: 15px;
}

.file-wrapper {
  box-shadow: inset 0 0 0 1px rgba(52, 61, 77, 0.13);
  box-shadow: inset 0 0 0 1px rgba(52, 61, 77, 0.13);
  color: #5f697a;
  display: block;
  width: 222px;
  height: 198px;
  display: inline-block;
  text-align: center;
  margin: 20px;
  padding-top: 40px;
}
</style>
